module.exports = __webpack_public_path__ + "img/choose-up-dejun.8db0b37c.png";